import { APPOINTMENT_TASK_TYPES } from 'constants/AppointmentConstants';
import { createReducer } from 'utils/ReduxUtils';

import { POST_SUCCESS, PUT_SUCCESS, RESCHEDULE_SUCCESS } from '../../../../appointmentTask/actionTypes';
import * as actionTypes from '../../../actionTypes';

const initialState = false;

const show = (_, { payload }) => payload.type === APPOINTMENT_TASK_TYPES.KEY_RETRIEVE;
const hide = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_BOOKING_MODAL]: show,
  [actionTypes.CLOSE_BOOKING_MODAL]: hide,
  [RESCHEDULE_SUCCESS]: hide,
  [POST_SUCCESS]: hide,
  [PUT_SUCCESS]: hide,
});
